/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DonutSegment } from './DonutSegment';
import {
    DonutSegmentFromJSON,
    DonutSegmentFromJSONTyped,
    DonutSegmentToJSON,
    DonutSegmentToJSONTyped,
} from './DonutSegment';
import type { QueryTimeRangeUtc } from './QueryTimeRangeUtc';
import {
    QueryTimeRangeUtcFromJSON,
    QueryTimeRangeUtcFromJSONTyped,
    QueryTimeRangeUtcToJSON,
    QueryTimeRangeUtcToJSONTyped,
} from './QueryTimeRangeUtc';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { SeriesGraphPoint } from './SeriesGraphPoint';
import {
    SeriesGraphPointFromJSON,
    SeriesGraphPointFromJSONTyped,
    SeriesGraphPointToJSON,
    SeriesGraphPointToJSONTyped,
} from './SeriesGraphPoint';

/**
 * Security Dashboard widget metrics (time series, donut, or KPI)
 * @export
 * @interface SecurityWidgetMetricsResponse
 */
export interface SecurityWidgetMetricsResponse {
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    yaxisLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    xaxisLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    kind?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityWidgetMetricsResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    userTimezone?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SecurityWidgetMetricsResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {QueryTimeRangeUtc}
     * @memberof SecurityWidgetMetricsResponse
     */
    queryTimeRangeUtc?: QueryTimeRangeUtc;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SecurityWidgetMetricsResponse
     */
    tenantContext?: { [key: string]: any; };
    /**
     * Dense daily buckets; present when kind is series
     * @type {Array<SeriesGraphPoint>}
     * @memberof SecurityWidgetMetricsResponse
     */
    points?: Array<SeriesGraphPoint>;
    /**
     * Horizontal axis title for time-series charts (local calendar span used for buckets). Omitted or null for donut and KPI responses.
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    xAxisLabel?: string;
    /**
     * Vertical axis title: Minutes for mtta/mttn/mttc (values are mean minutes per bucket); Totals for caseCount. Omitted or null for donut and KPI responses.
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    yAxisLabel?: string;
    /**
     * 
     * @type {Array<DonutSegment>}
     * @memberof SecurityWidgetMetricsResponse
     */
    segments?: Array<DonutSegment>;
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetMetricsResponse
     */
    displayMode?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityWidgetMetricsResponse
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityWidgetMetricsResponse
     */
    trendPercent?: number;
}

/**
 * Check if a given object implements the SecurityWidgetMetricsResponse interface.
 */
export function instanceOfSecurityWidgetMetricsResponse(value: object): value is SecurityWidgetMetricsResponse {
    return true;
}

export function SecurityWidgetMetricsResponseFromJSON(json: any): SecurityWidgetMetricsResponse {
    return SecurityWidgetMetricsResponseFromJSONTyped(json, false);
}

export function SecurityWidgetMetricsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityWidgetMetricsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'yaxisLabel': json['yaxisLabel'] == null ? undefined : json['yaxisLabel'],
        'xaxisLabel': json['xaxisLabel'] == null ? undefined : json['xaxisLabel'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'success': json['success'] == null ? undefined : json['success'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'queryTimeRangeUtc': json['queryTimeRangeUtc'] == null ? undefined : QueryTimeRangeUtcFromJSON(json['queryTimeRangeUtc']),
        'tenantContext': json['tenantContext'] == null ? undefined : json['tenantContext'],
        'points': json['points'] == null ? undefined : ((json['points'] as Array<any>).map(SeriesGraphPointFromJSON)),
        'xAxisLabel': json['xAxisLabel'] == null ? undefined : json['xAxisLabel'],
        'yAxisLabel': json['yAxisLabel'] == null ? undefined : json['yAxisLabel'],
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(DonutSegmentFromJSON)),
        'displayMode': json['displayMode'] == null ? undefined : json['displayMode'],
        'value': json['value'] == null ? undefined : json['value'],
        'trendPercent': json['trendPercent'] == null ? undefined : json['trendPercent'],
    };
}

export function SecurityWidgetMetricsResponseToJSON(json: any): SecurityWidgetMetricsResponse {
    return SecurityWidgetMetricsResponseToJSONTyped(json, false);
}

export function SecurityWidgetMetricsResponseToJSONTyped(value?: SecurityWidgetMetricsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'yaxisLabel': value['yaxisLabel'],
        'xaxisLabel': value['xaxisLabel'],
        'kind': value['kind'],
        'success': value['success'],
        'userTimezone': value['userTimezone'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'queryTimeRangeUtc': QueryTimeRangeUtcToJSON(value['queryTimeRangeUtc']),
        'tenantContext': value['tenantContext'],
        'points': value['points'] == null ? undefined : ((value['points'] as Array<any>).map(SeriesGraphPointToJSON)),
        'xAxisLabel': value['xAxisLabel'],
        'yAxisLabel': value['yAxisLabel'],
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(DonutSegmentToJSON)),
        'displayMode': value['displayMode'],
        'value': value['value'],
        'trendPercent': value['trendPercent'],
    };
}

